const bfcList: string[] = [
  "Wisam Brikho",
  "Dustin Frigy",
  "Deborah Melding",
  "Carol Simpson",
  "Mike Laramy",
];

export default bfcList;
